import axios from 'axios';
// import store from '../store/index'
import { message } from 'ant-design-vue';


const ajax = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 16000,
});
//
ajax.interceptors.request.use(config => {
    //请求前
    let token = localStorage.getItem('token');
    if(token){
        config.headers.Authorization = token;
    }
    // if(!config.headers.NO_LOADING){
    //   message.loading()
    // }
    return config
}, error => {

    Promise.reject(error);
});

ajax.interceptors.response.use(

  response => {
    const res = response.data
    //请求后
    if(res.code === 200){
      return res.data
    }else{
      message.error({
        content : res.message
      })

      if(res.code == 417){
        sessionStorage.clear();
        localStorage.clear();
        location.replace(location.origin + '/train_pc/login');
        return;
      }

      return Promise.reject(res)
    }
  },
  error => {
    message.error({
      content : '您的网络飘到外太空了~'
    })
    const errorResponse = error.response;
    
    return Promise.reject(errorResponse)
  });

export default ajax
